"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAINNET_POLKADOT_CONFIG = exports.MAINNET_KUSAMA_CONFIG = exports.MAINNET_ROCOCO_CONFIG = exports.MAINNET_WESTEND_CONFIG = exports.GOERLI_POLKADOT_CONFIG = exports.GOERLI_KUSAMA_CONFIG = exports.GOERLI_ROCOCO_CONFIG = exports.GOERLI_WESTEND_CONFIG = exports.DEVELOP_POLKADOT_CONFIG = exports.DEVELOP_KUSAMA_CONFIG = exports.DEVELOP_ROCOCO_CONFIG = exports.DEVELOP_WESTEND_CONFIG = exports.DEVELOP_CONFIG = void 0;
/**
 * @deprecated use other configs
 */
exports.DEVELOP_CONFIG = {
    polkadotUrl: 'wss://westend-rpc.polkadot.io',
    baseUrl: 'https://api.dev.stkr.io/',
    crowdloanStatusCheck: false,
    cacheAge: 3000,
    networkType: 'WND',
};
const createSlotAuctionConfig = (networkType, currentEnv) => {
    const polkadotUrls = {
        'WND': 'wss://westend-rpc.polkadot.io',
        'ROC': 'wss://rococo-rpc.polkadot.io',
        'KSM': 'wss://kusama-rpc.polkadot.io',
        'DOT': 'wss://rpc.polkadot.io',
    };
    const apiUrls = {
        'develop': 'https://api.dev.stkr.io/',
        'goerli': 'https://api.goerli.stkr.io/',
        'prod': 'https://api.stkr.io/',
    };
    return {
        polkadotUrl: polkadotUrls[networkType],
        baseUrl: apiUrls[currentEnv],
        crowdloanStatusCheck: currentEnv === 'prod',
        cacheAge: 10000,
        networkType: networkType,
    };
};
exports.DEVELOP_WESTEND_CONFIG = createSlotAuctionConfig('WND', 'develop');
exports.DEVELOP_ROCOCO_CONFIG = createSlotAuctionConfig('ROC', 'develop');
exports.DEVELOP_KUSAMA_CONFIG = createSlotAuctionConfig('KSM', 'develop');
exports.DEVELOP_POLKADOT_CONFIG = createSlotAuctionConfig('DOT', 'develop');
exports.GOERLI_WESTEND_CONFIG = createSlotAuctionConfig('WND', 'goerli');
exports.GOERLI_ROCOCO_CONFIG = createSlotAuctionConfig('ROC', 'goerli');
exports.GOERLI_KUSAMA_CONFIG = createSlotAuctionConfig('KSM', 'goerli');
exports.GOERLI_POLKADOT_CONFIG = createSlotAuctionConfig('DOT', 'goerli');
exports.MAINNET_WESTEND_CONFIG = createSlotAuctionConfig('WND', 'prod');
exports.MAINNET_ROCOCO_CONFIG = createSlotAuctionConfig('ROC', 'prod');
exports.MAINNET_KUSAMA_CONFIG = createSlotAuctionConfig('KSM', 'prod');
exports.MAINNET_POLKADOT_CONFIG = createSlotAuctionConfig('DOT', 'prod');
//# sourceMappingURL=config.js.map